<template>
  <div id="app">
    <div id="wrapper">
      <div id="mainMenu" :class="{scrolled: scrollPosition > 96}">
        <header-component></header-component>
      </div>
      <div id="mainContent">
        <router-view :key="$route.path"></router-view>
      </div>
    </div>
    <browser-check></browser-check>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'app',
  data () {
    return {
      scrollPosition: window.scrollY
    }
  },
  mounted: function () {
    window.addEventListener('scroll', this.updateScroll)
  },
  methods: {
    ...mapActions(['getAccessToken', 'getDataToken', 'getSingleFullAccountData', 'getUserDetails']),
    updateScroll () {
      this.scrollPosition = window.scrollY
    }
  },
  created () {
    document.title = 'PEA'
    const accounts = this.$msalInstance.getAllAccounts()
    this.$msalInstance.setActiveAccount(accounts[0])
    this.$store.state.userInfo.account = accounts[0]
    this.getDataToken(this.$msalInstance).then(() => {
      this.getSingleFullAccountData(this.$store.state.userInfo.account.username)
        .then(() => {
          this.getUserDetails(this.$store.state.userInfo.fullAccount.onPremisesSamAccountName)
        })
    })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#mainContent {
  padding: 40px;
}

#mainContent a {
  color: #00a9ce;
}

a.el-upload-list__item-name {
  white-space: normal;
  word-break: break-word;
}

/* General Elements */
hr {
  border-top: 3px solid #00a9ce !important;
  margin-bottom: 1.5rem !important;
}

hr.thin {
  border-width: 1px !important;
  border-color: #eee !important;
}

button:hover {
  cursor: pointer;
}

.card {
  border-radius: .4rem !important;
}

.card-header {
  padding: .95rem 1.25rem !important;
}

.card-block {
  padding: 20px;
}

#mainMenu.scrolled {
  box-shadow: 0 0 10px rgba(0,0,0,.5);
  position: fixed;
  margin-top: -97px;
  transform: translateZ(0);
}

#mainMenu .el-menu--horizontal {
  background: rgb(238,241,246);
  border-bottom: none;
}

#mainMenu .el-submenu__title, #mainMenu .el-menu-item {
  color: rgb(72,87,106);
}

#mainMenu .el-submenu__title:hover {
  background: rgb(238,241,246);
}

#mainMenu .el-menu-item:hover {
  background: rgb(238,241,246);
}

.el-menu-item.is-active {
  border-bottom: 2px solid #00a9c3;
}

.el-menu .el-menu-item.is-active {
  background: none;
}

.el-menu .el-menu .el-menu-item.is-active {
  border-bottom: none;
}

.el-submenu.is-active .el-submenu__title {
  border-bottom-color: #00a9ce;
}

/* Headings */
h3 {
  background: #00a9ce;
  color: white !important;
  padding: 8px 20px;
  border-radius: 10px 10px 0 0;
  margin-bottom: 0 !important;
  position: relative;
  z-index: 2;
  /*transition: .25s;*/
  /*border-bottom: 1px solid #999;*/
}

h3.closed {
  border-radius: 10px;
  transition: .2s;
}

/* PEA Panels */
.pea-panel {
  /*background: aliceblue;*/
  padding: 30px 20px 10px 20px;
  border-radius: 0 0 10px 10px;
  border: 1px solid #00a9ce;
  overflow: hidden;
  /*border-top: 1px solid #ccc;*/
}

.panel-enter-active, .panel-leave-active {
    transition: .2s;
    opacity: 1;
    top: 0;
    position: relative;
    max-height: 10000px;
}

.panel-enter, .panel-leave {
  opacity: 0;
  top: -20px;
  max-height: 0;
}

.toggle {
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid white;
  position: absolute;
  right: 20px;
  top: 20px;
  transition: .25s;
  z-index: 3;
}

.toggle:hover {
  cursor: pointer;
  filter: drop-shadow(0 0 2px rgba(0,0,0,.5));
}

.toggle.closed {
  transform: rotate(180deg);
}

/* Forms */
.el-form-item__label {
  text-align: left;
  font-weight: bold;
}

.el-checkbox__label {
  float: left;
  padding-left: 0;
  margin-right: 7px;
  color: rgb(72, 87, 106);
  font-weight: bold;
}
.el-checkbox__inner::after{
  height: 15px !important;
  width: 6px !important;
  left: 8px !important;
}
.el-checkbox__inner{
  height: 25px !important;
  width: 25px !important;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #009ACE !important;
}
.el-select {
  width: 100%;
}

.el-select-group__title {
  padding-left: 20px !important;
  font-size: .9em;
  color: black;
  font-weight: bold;
}

.el-select-group .el-select-dropdown__item {
  padding-left: 40px;
}

.el-form-item {
  margin-bottom: 12px;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
  color: inherit;
}

.el-form-item__error {
  top: auto;
}

/* Financial Assets */
.card {
  margin-bottom: 15px;
}

.deleteAssetButton {
  position: absolute;
  z-index: 10;
  top: 10px;
  right: 20px;
}

.assetsTotalRow {
  padding: 0 20px 10px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Notifications */
.el-alert {
  margin-bottom: 20px;
}

.el-alert__content {
  margin: 0 auto;
}

/* Bootstrap/Element.io overrides */
.btn-primary, .el-button--primary {
  background-color: #00a9ce !important;
  border-color: #00a9ce !important;
  transition: .25s !important;
}

.btn-primary:hover, .el-button--primary:hover {
  background-color: #00a9ce !important;
  border-color: #00a9ce !important;
  opacity: .75;
}

/* Tables */
.el-table {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  background-color: #fff;
  border: 1px solid rgb(223, 230, 236);
  border-bottom: none;
  font-size: 14px;
  color: rgb(31, 45, 61);
}

.el-table__header-wrapper thead div, .el-table__footer-wrapper thead div, .el-table__header-wrapper th {
  background: rgb(238,241,246);
  color: rgb(31,45,61);
}

.peaTable .cell {
  padding-top: 5px;
  padding-bottom: 5px;
}

.el-table .cell, .el-table td, .el-table th {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  word-break: normal;
}

.el-pagination.is-background .el-pager li.active {
  background-color: #00a9ce;
}

.el-pagination.is-background .el-pager li:hover {
  color: #00a9ce;
}

/* CKEditor */
.cke_chrome {
  box-shadow: none !important;
  border-color: #d8dce5 !important;
  border-radius: 4px;
}

.cke_editor:focus {
  border-color: #00a9ce !important;
}

.cke_inner {
  border-radius: 4px;
}

.cke_top {
  border-radius: 4px 4px 0 0;
}

.cke_bottom {
  background-color: #8090a0 !important;
  border-radius: 0 0 4px 4px;
}

.is-error .cke_chrome {
  border-color: #f56c6c !important;
}

.is-success .cke_chrome {
  border-color: #67c23a !important;
}

@media only screen and (min-width: 992px){
  .el-col-md-0 {
    display: block;
  }
}

.el-dialog {
  width: 30%;
  text-align: center;
}

.el-table th.el-table__cell{
    background-color: #eef1f6;

}
/*** IE Fixes ***/
.el-main {
  overflow: visible !important;
}
.el-popover {
word-break: break-word;
}

/* Hide CKEDITOR Warning Message */
.cke_notifications_area {
  display: none !important;
}
</style>
